import angular from 'angular';
import components from './components';
import complaintsRegister from './complaintsRegister';

export default angular
  .module('scenes.complaintsRegister', [components])
  .component('complaintsRegister', complaintsRegister).name;
